import React from "react";
import { useTranslation } from "react-i18next";
import { Typography, Form, Space, Input, DatePicker } from "antd";
import MainHeader, { MENU_REPORT } from "../../components/common/MainHeader";
import ReportExportButton from "../../components/common/ReportExportButton";
import { URL_BARCODE } from "../../constance/urls";
import TSTable from "../../components/common/TSTable";
import { DATE_FORMAT, HUMAN_DATE_FORMAT } from "../../constance/strings";
import { useDebounce } from "use-debounce";
import dayjs from "dayjs";

export default function ReportWoodImportListView() {
  const { t } = useTranslation();
  const tableRef = React.useRef();
  const [form] = Form.useForm();

  const date = Form.useWatch("created", form);
  const [searchText, setSearchText] = React.useState("");
  const [debouncedText] = useDebounce(searchText, 500);
  const [hasSearched, setHasSearched] = React.useState(false);

  const columns = React.useMemo(
    () => [
      {
        title: t("date"),
        dataIndex: "created",
        render: (_, original) =>
          new Date(original.created).toLocaleString("en-GB"),
      },
      {
        title: t("wood_imports.order_no"),
        dataIndex: "order_no",
      },
      {
        title: t("truck_transactions.company"),
        dataIndex: "truck_company_name",
      },
      {
        title: t("trucks.type"),
        dataIndex: "truck_type_name",
      },
      {
        title: () => null,
        dataIndex: "id",
        render: (_, original) => (
          <div style={{ textAlign: "center" }}>
            {["pdf"].map((type) => (
              <ReportExportButton
                url={`${URL_BARCODE.REPORT_WOOD_IMPORT_EXPORT}${type}/?id=${original.id}`}
                type={type}
                title={`${t(
                  "menus.report_menus.wood_import_menus.wood_import_detail"
                )}.....`}
              />
            ))}
          </div>
        ),
      },
    ],
    [t, date]
  );

  React.useEffect(() => {
    if (!hasSearched) {
      setHasSearched(true);
      return;
    } else {
      const formattedDate = date ? dayjs(date).format(DATE_FORMAT) : null;
      const params = {
        date: formattedDate,
        search: debouncedText,
      };
      tableRef.current.fetch(params);
    }
  }, [date, debouncedText]);

  return (
    <div style={{ margin: "24px", marginTop: "7em" }}>
      <MainHeader activeItem={MENU_REPORT} />
      <Typography.Title level={2}>
        {t("menus.report_menus.wood_import_menus.wood_import_detail")}
      </Typography.Title>
      <Form form={form}>
        <Space style={{ float: "left" }}>
          <Form.Item label={t("searchs.fields.date")} name={"created"}>
            <DatePicker
              format={HUMAN_DATE_FORMAT}
              placeholder={t("searchs.placeholders.date")}
              style={{ width: 200 }}
            />
          </Form.Item>
          <Form.Item label={t("search")}>
            <Input
              placeholder={t("search")}
              allowClear
              onChange={(e) => setSearchText(e.target.value)}
            />
          </Form.Item>
        </Space>
      </Form>

      <TSTable
        scroll={{ x: 1000 }}
        ref={tableRef}
        url={URL_BARCODE.WOOD_IMPORT_TRANSACTION}
        columns={columns}
        params={{ date: date, search: debouncedText || "" }}
      />
    </div>
  );
}
